import * as actionTypes from './actionTypes'

// const processChildWidgetSFMapping = async ({ widget, path: elemPath }, type, path, widgetState, customParams, state, dispatch) => {
//     if (widget && widget.Type === 'view' && _.get(widget, 'Props.sfMapping')) {
//         const sfMapping = _.get(widget, 'Props.sfMapping');
//         let widgetsData = {};
//         let hashCustomActions = {};
//         let isBackgroundMode = false;
//         if (type === 'custom') {
//             isBackgroundMode = true;
//         }
//         if (isImmutable(customParams)) {
//             _.each(customParams.toJS(), function (job) {
//                 if (!job.runInBackground) {
//                     isBackgroundMode = false;
//                 }
//                 _.each(job.items, function (row) {
//                     hashCustomActions[row.value] = row;
//                 });
//             });
//         }
//         if (isImmutable(widgetState)) { widgetsData = widgetState.toJS(); }
//         const params = getParams(state); //_.get(params, elemPath, {}) if incorrect path
//         if (path && _.isArray(path)) { path = path.join("."); }
//         let messages = [];
//         const list = recursivePrepareSFMapping(sfMapping, type, path, widgetsData, params, false, messages, hashCustomActions);
//         if (isBackgroundMode) { messages = []; }
//         if (messages.length > 0) {
//             dispatch({
//                 type: actionTypes.SHOW_LOADING_WINDOW,
//                 payload: {
//                     messages: messages
//                 }
//             });
//         }
//         const { status, data } = await axios.post('/ftwidget/get/sfmapping', {
//             data: {
//                 list,
//             },
//             widgetID: widget._id
//         });
//         let isShowLoading = false;
//         let loadingMessages = {};
//         if (data && data.messages && Object.keys(data.messages).length) {
//             isShowLoading = true;
//             loadingMessages.type = 'error';
//             loadingMessages.isAlloClose = true;
//             loadingMessages.list = [];
//             _.each(data.messages, (msg) => {
//                 loadingMessages.list.push(msg);
//             });
//         }
//         dispatch({
//             type: actionTypes.PROCESS_SF_CHILD_MAPPING,
//             payload: {
//                 path: elemPath,
//                 data,
//                 isShowLoading,
//                 loadingMessages,
//                 sfMessages: data.messages,
//                 inQuery: true
//             }
//         });
//     }
// };
// const processPortalChildWidgetSFMapping = async ({ widget, path: elemPath }, type, path, widgetState, customParams, state, dispatch) => {
//     if (widget.Type === 'view' && _.get(widget, 'Props.sfMapping')) {
//         const sfMapping = _.get(widget, 'Props.sfMapping');
//         let widgetsData = {};
//         let hashCustomActions = {};
//         let isBackgroundMode = false;
//         if (type === 'custom') {
//             isBackgroundMode = true;
//         }
//         if (isImmutable(customParams)) {
//             _.each(customParams.toJS(), function (job) {
//                 if (!job.runInBackground) {
//                     isBackgroundMode = false;
//                 }
//                 _.each(job.items, function (row) {
//                     hashCustomActions[row.value] = row;
//                 });
//             });
//         }
//         if (isImmutable(widgetState)) { widgetsData = widgetState.toJS(); }
//         const params = getParams(state); // _.get(params, elemPath, {}) //if incorrect path
//         if (path && _.isArray(path)) { path = path.join("."); }
//         let messages = [];
//         const list = recursivePrepareSFMapping(sfMapping, type, path, widgetsData, params, false, messages, hashCustomActions);
//         if (isBackgroundMode) { messages = []; }
//         if (messages.length > 0) {
//             dispatch({
//                 type: actionTypes.SHOW_LOADING_WINDOW,
//                 payload: {
//                     messages: messages
//                 }
//             });
//         }
//         const { status, data } = await axios.post('/ftwidget/sfmapping/get', {
//             data: {
//                 list,
//             },
//             widgetID: widget._id
//         });
//         let isShowLoading = false;
//         let loadingMessages = {};
//         if (data && data.messages && Object.keys(data.messages).length) {
//             isShowLoading = true;
//             loadingMessages.type = 'error';
//             loadingMessages.isAlloClose = true;
//             loadingMessages.list = [];
//             _.each(data.messages, (msg) => {
//                 loadingMessages.list.push(msg);
//             });
//         }
//         dispatch({
//             type: actionTypes.PROCESS_SF_CHILD_MAPPING,
//             payload: {
//                 path: elemPath,
//                 data,
//                 isShowLoading,
//                 loadingMessages,
//                 sfMessages: data.messages,
//                 inQuery: true
//             }
//         });
//     }
// };
export const addToSFQuery = (list) => (dispatch) => {
  dispatch({
    type: actionTypes.QUERY_ADD,
    payload: {
      list,
    },
  })
}
